// Canned update messages for admin to quickly add client-facing updates
export const CANNED_UPDATES = [
  "Landing page design mockup is ready for your review.",
  "Copy approved with minor edits. Updated version received.",
  "Homepage copy draft completed and sent for review.",
  "Received logo files. Looking great!",
  "Kickoff call notes shared. Project timeline confirmed.",
  "Logo successfully received and uploaded.",
  "Awaiting response from client.",
  "Asset review completed — moving to next stage.",
  "Project is now in the Design Phase.",
  "Ad copy draft completed — pending client review.",
  "All materials submitted. Beginning production.",
  "Client assets incomplete — request sent.",
  "Internal revisions in progress.",
  "This project has been prioritized by the team.",
  "Project timeline updated."
];
